<pbds-page-title l10nTranslate ttl="INVENTORY_VELOCITY.TITLE" layout="container-fluid"></pbds-page-title>
<div class="container-fluid">
  <div *ngIf="showWarning" class="alert alert-warning" role="alert">
    {{ warningMessage }}
    <i
      class="pbi-icon-mini lg ml-2 pbi-info-circle-open"
      style="color: #605077"
      aria-hidden="true"
      ngbTooltip="Currently only Product SKU filter is being supported. Enter the product SKU in the serach text box to get filtered data"
      placement="auto"
      triggers="click hover focus blur"
      placement="right auto"
    ></i>
  </div>
  <div class="row">
    <div class="col">
      <div class="toolbar">
        <div class="toolbar-left">
          <div ngbDropdown>
            <button
              class="btn btn-secondary btn-sm mr-2 ml-2"
              id="export"
              ngbDropdownToggle
              aria-label="Export"
              l10nTranslate
            >
              <i class="pbi-icon-mini pbi-download" l10nTranslate></i>
              INVENTORY_VELOCITY.DOWNLOAD
            </button>
            <div ngbDropdownMenu aria-labelledby="export">
              <button class="dropdown-item" (click)="download('all')" l10nTranslate>
                INVENTORY_VELOCITY.DOWNLOAD_ALL_DATA
              </button>
              <button class="dropdown-item" (click)="download('filtered')" l10nTranslate *ngIf="data?.length != 0">
                INVENTORY_VELOCITY.DOWNLOAD_FILTERED_DATA
              </button>
            </div>
          </div>
        </div>

        <div class="toolbar-right">
          <pbds-daterange-popover
            #daterange
            [minDate]="daterangeMinDate"
            [applyText]="applyTextLocalization"
            [cancelText]="cancelTextLocalization"
            [customRangeText]="customRangeTextLocalization"
            [presets]="daterangePresets"
            [presetSelected]="daterangePresetSelected"
            [filters]="daterangeFilters"
            (dateChange)="onDaterangeChange($event)"
          ></pbds-daterange-popover>

          <form [formGroup]="calendarForm"></form>
          <div class="toolbar-divider">&nbsp;</div>

          <div class="input-group">
            <div class="input-group-text">
              <span class="input-group-text" id="basic-addon4" aria-label="Search">
                <i class="pbi-icon-mini pbi-search" aria-hidden="true"></i>
              </span>
            </div>
            <input
              type="search"
              class="form-control"
              placeholder="{{ searchSKU }}"
              aria-label="Search"
              aria-describedby="basic-addon4"
              [(ngModel)]="productSKU"
              (keypress)="searchBySKU($event)"
              (input)="handleSearchInput($event)"
            />
          </div>
          <div class="toolbar-divider">&nbsp;</div>
          <pbds-column-toggle [columns]="cols" [minimum]="1"> </pbds-column-toggle>
        </div>
      </div>
      <div class="table-responsive">
        <p-table
          [value]="data"
          responsiveLayout="scroll"
          [paginator]="true"
          [rows]="rowSize"
          [totalRecords]="totalElements"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="
            totalElements ? 'Showing {first} to {last} of ' + totalElements + ' entries' : ''
          "
          [rowsPerPageOptions]="[10, 25, 50, 100]"
          [lazy]="true"
          [lazyLoadOnInit]="false"
          [autoLayout]="true"
          dataKey="productSKU"
          rowExpandMode="single"
          [loading]="isLoading"
          [sortOrder]="sortType.sortOrder === 'asc' ? 1 : -1"
          [sortField]="sortType.name"
          [(first)]="first"
          (onRowExpand)="onRowExpand($event)"
          (onLazyLoad)="loadNodes($event)"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th style="width: 0.1em" scope="col"></th>
              <ng-container *ngFor="let col of cols">
                <ng-container>
                  <th
                    *ngIf="col.sortable && col.toggle.selected"
                    [ngStyle]="{ width: col.width, 'text-align': col.align, 'padding-left': col.paddingLeft }"
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="!col.sortable ? true : false"
                    [ngStyle]="{ 'text-align': col.align }"
                  >
                    {{ col.header }}
                    <ng-container *ngIf="col.sortable">
                      <p-sortIcon [field]="col.field"></p-sortIcon>
                    </ng-container>
                  </th>
                  <th
                    *ngIf="col.toggle.selected && !col.sortable"
                    scope="col"
                    [ngStyle]="{ 'text-align': col.align, width: col.width }"
                  >
                    {{ col.header }}
                    <i
                      class="pbi-icon-mini pbi-info-circle text-info"
                      ngbTooltip="{{ col.tooltipMsg }}"
                      placement="top"
                      triggers="hover focus:blur"
                      container="body"
                      *ngIf="col.isTooltip"
                    ></i>
                  </th>
                </ng-container>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">
            <tr>
              <td>
                <a
                  href="#"
                  [pRowToggler]="rowData"
                  class="table-row-toggle"
                  [attr.aria-label]="expanded ? 'Collapse row' : 'Expand row'"
                >
                  <i
                    [ngClass]="expanded ? 'pbi-icon-mini pbi-minimal-down' : 'pbi-icon-mini pbi-minimal-right'"
                    aria-hidden="true"
                  ></i>
                </a>
              </td>
              <ng-container *ngFor="let col of cols; let i = index">
                <td
                  *ngIf="col.toggle.selected"
                  allign="center"
                  [ngClass]="{
                    'text-center':
                      rowData[col.field] == undefined &&
                      (col.field == 'outofStockDate' ||
                        col.field == 'lastReceivedDate' ||
                        col.field == 'lastShippedDate')
                  }"
                  [ngStyle]="{ 'text-align': col.align }"
                >
                  <!-- <td *ngIf="col.toggle.selected" allign="center" [ngStyle]="{ 'text-align': col.align }"> -->
                  <div>
                    <a *ngIf="col.header === 'item'"> {{ rowData['productDescription'] }} </a>
                  </div>
                  <div *ngIf="col.header != 'Total Retail Value' && col.header != 'Velocity'">
                    {{ rowData[col.field] != undefined || rowData[col.field] != null ? rowData[col.field] : '-' }}
                  </div>
                  <div *ngIf="col.header === 'Total Retail Value'">
                    {{
                      rowData[col.field] != undefined || rowData[col.field] != null
                        ? (rowData[col.field] | currency)
                        : '-'
                    }}
                  </div>
                  <div *ngIf="col.header === 'Velocity'">
                    {{
                      rowData[col.field] != undefined || rowData[col.field] != null
                        ? (rowData[col.field] | number : '1.2-2') + '%'
                        : '-'
                    }}
                  </div>
                </td>
              </ng-container>
            </tr>
          </ng-template>

          <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" let-i="rowIndex">
            <ng-container>
              <tr *ngIf="isSkuDetailsLoading">
                <span class="pbi-icon-outline pbi-loader-circle spin lg ml-3"></span>
              </tr>
            </ng-container>
            <ng-container *ngFor="let warehouse of warehouseDetails; let i = index">
              <tr id="rowexpandid" class="table-details" aria-live="polite" role="alert">
                <td></td>
                <td>{{ formatFacilityName(warehouse.warehouseName) }}</td>
                <td *ngIf="isColumnSelected('numOfShipments')" class="text-right">
                  {{
                    warehouse.numOfShipments != undefined || warehouse.numOfShipments != null
                      ? warehouse.numOfShipments
                      : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('totalShipped')" class="text-right">
                  {{
                    warehouse.totalShipped != undefined || warehouse.totalShipped != null ? warehouse.totalShipped : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('totalProductRetailValue')" class="text-right">
                  {{
                    warehouse.totalProductRetailValue != undefined || warehouse.totalProductRetailValue != null
                      ? (warehouse.totalProductRetailValue | currency)
                      : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('availableInventory')" class="text-right">
                  {{
                    warehouse.availableInventory != undefined || warehouse.availableInventory != null
                      ? warehouse.availableInventory
                      : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('velocity')" class="text-right">
                  {{
                    warehouse.velocity != undefined || warehouse.velocity != null
                      ? (warehouse.velocity | number : '1.2-2') + '%'
                      : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('outofStockDate')" class="text-left">
                  {{
                    warehouse.outofStockDate != undefined || warehouse.outofStockDate != null
                      ? (warehouse.outofStockDate | date : 'MM/dd/YYYY')
                      : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('thirtyDaysReplnQty')" class="text-right">
                  {{
                    warehouse.thirtyDaysReplnQty != undefined || warehouse.thirtyDaysReplnQty != null
                      ? warehouse.thirtyDaysReplnQty
                      : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('lastReceivedDate')" class="text-left">
                  {{
                    warehouse.lastReceivedDate != undefined || warehouse.lastReceivedDate != null
                      ? (warehouse.lastReceivedDate | date : 'MM/dd/YYYY')
                      : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('lastShippedDate')" class="text-left">
                  {{
                    warehouse.lastShippedDate != undefined || warehouse.lastShippedDate != null
                      ? (warehouse.lastShippedDate | date : 'MM/dd/YYYY')
                      : '-'
                  }}
                </td>
                <td *ngIf="isColumnSelected('pendingShipments')" class="text-right">
                  {{
                    warehouse.pendingShipments != undefined || warehouse.pendingShipments != null
                      ? warehouse.pendingShipments
                      : '-'
                  }}
                </td>
              </tr>
            </ng-container>
          </ng-template>

          <ng-template pTemplate="emptymessage" let-columns>
            <tr *ngIf="!isLoading">
              <td class="text-center" colspan="13">
                <div class="empty-state empty-state-search">
                  <div *ngIf="data?.length === 0">
                    <div class="empty-state-icon" aria-hidden="true">
                      <img src="assets/images/commonIcon/empty-state-icon.svg" />
                    </div>
                    <div class="empty-state-head" l10nTranslate>INVENTORY_VELOCITY.NO-RESULTS-FOUND</div>
                    <div class="empty-state-body" l10nTranslate>INVENTORY_VELOCITY.TRY-OTHER-FILTERS</div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div style="visibility: hidden; height: 150px"></div>
      </div>
    </div>
  </div>
</div>
